import React, { useState } from "react";
import Slot from "./Slot";
import { Typography, Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

const INITIAL_SLOTS_TO_SHOW = 3;
const SLOTS_PER_ROW = 3;

function RenderSlot({
  label,
  availability,
  updateItem,
  practitioner,
  reason,
  matchingRequest,
  practiceId,
  reservationRequest,
  deleteReservationRequest,
  themeColor,
  date,
}) {
  const [expanded, setExpanded] = useState(false);

  if (!availability || availability.length === 0) {
    return (
      <Typography.Text type="secondary" style={{ fontSize: 13 }}>
        {label}: No slots available
      </Typography.Text>
    );
  }

  const hasMore = availability.length > INITIAL_SLOTS_TO_SHOW;
  const slotsToShow = expanded ? availability : availability.slice(0, INITIAL_SLOTS_TO_SHOW);
  const remainingCount = availability.length - INITIAL_SLOTS_TO_SHOW;

  return (
    <div style={{ marginBottom: 12 }}>
      <Typography.Text type="secondary" style={{ fontSize: 12, marginBottom: 8, display: 'block' }}>
        {label}
      </Typography.Text>
      <div style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${SLOTS_PER_ROW}, 1fr)`,
        gap: 8,
      }}>
        {slotsToShow.map((startTime, index) => (
          <Slot
            key={index}
            themeColor={themeColor}
            date={date}
            startTime={startTime}
            updateItem={updateItem}
            practitioner={practitioner}
            reason={reason}
            doesMatching={
              matchingRequest && matchingRequest.startTime === startTime
            }
            practiceId={practiceId}
            reservationKey={matchingRequest?.reservationKey}
            anyBatch={matchingRequest?.anyBatch}
            reservationRequest={reservationRequest}
            deleteReservationRequest={deleteReservationRequest}
          />
        ))}
      </div>
      {hasMore && (
        <Button
          type="link"
          size="small"
          onClick={() => setExpanded(!expanded)}
          icon={expanded ? <UpOutlined /> : <DownOutlined />}
          style={{ padding: '4px 0', height: 'auto', fontSize: 12, marginTop: 4, color: themeColor || undefined }}
        >
          {expanded ? 'Show less' : `+${remainingCount} more`}
        </Button>
      )}
    </div>
  );
}

export default RenderSlot;
